import { BaseEntity } from "@app/models/rest/base-entity";
import { Visit } from "@app/models/rest/visit";
import { BookingReason } from "@app/models/rest/booking-reason";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("visitBookingReasons")
export class VisitBookingReason extends BaseEntity {
  bookingDate: Date;
  reason: BookingReason;
  visit: Visit;
  note: string;
  originalStartDate: Date;
  originalEndDate: Date;
  newStartDate: Date;
  newEndDate: Date;
  displayedSlotRanking: number;
}
